import React, { useState, useEffect } from 'react'
import { BiUser } from "react-icons/bi"
import { BsBriefcase } from "react-icons/bs"
import { FaBars, FaRegBell, FaPowerOff, FaRegUser, FaDownload } from "react-icons/fa6";
import { FiSettings, FiLock } from 'react-icons/fi'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SIDEBAR from './Sidebar';
import { Button, Spinner } from 'react-bootstrap';
import { LuTrophy } from "react-icons/lu"
import { useDispatch, useSelector } from 'react-redux';
import { notificationTodo } from '../../LMS_Redux/LMS_Slices/Notification/Notification';
import { updateTourSettingTodo } from '../../LMS_Redux/LMS_Slices/Assets/UpdateTourSetting';
import { SignOutRes, SignOutTodo } from '../../LMS_Redux/LMS_Slices/Assets/SignOut';
import { form16Todo } from '../../LMS_Redux/LMS_Slices/Hr/Form16';

export default function HEADER(props) {

    let user = JSON.parse(localStorage.getItem('user_data'))
    let tour = localStorage.getItem('tour_toggle') === 'true'
    const [bool, setBool] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [spinnerForm16, setSpinnerForm16] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const count = useSelector(state => state.notification && state.notification.data && state.notification.data.data)

    const logout = () => {
        setSpinner(true)
        dispatch(SignOutTodo()).then(res => {
            // console.log(res, 'res')
            // console.log(SignOutRes, 'SignOutRes')
            if (res?.payload?.success) {
                localStorage.clear();
                navigate('/login');
                setSpinner(false)
            }
            else {
                alert(SignOutRes.message, { position: "bottom-right" });
                setSpinner(false)
            }
        })
    }

    const location = useLocation();
    const path = location.pathname

    const report_page = () => {
        navigate('/user_report', { state: JSON.parse(localStorage.getItem('user_data')) })
    }

    const tour_setting = (e) => {
        dispatch(updateTourSettingTodo(e)).then(res => {
            if (res?.payload?.success) {
                localStorage.setItem('tour_toggle', res?.payload?.data?.tour_status)
                setBool(!bool)
            }
        })
    }

    const form_16 = () => {
        setSpinnerForm16(true)

        dispatch(form16Todo()).then((res) => {
            if (res?.payload?.success) {
                setSpinnerForm16(false)
                window.open(res?.payload?.data, "_blank")
            } else {
                setSpinnerForm16(false)
                alert(res?.payload?.message, { position: "bottom-right" })
            }
        })
    }

    useEffect(() => {
        if (props.sidebar) {
            var marginAll = document.getElementById("content");
            marginAll.classList.add('margin-all-page')
        }
        else {
            var marginAll = document.getElementById("content");
            marginAll.classList.remove('margin-all-page')
        }
    })

    useEffect(() => {
        dispatch(notificationTodo())
    }, [bool])

    return (
        <>
            <nav className="navbar fixed-top bg-light nav_head">
                <div className="container-fluid">
                    <div className='d-flex align-items-center'>
                        <a className="navbar-brand nav_logo">
                            <img src="./rexolms.png" alt="" className='img-fluid' />
                        </a>
                        {path !== '/course_quiz' ?
                            <>
                                <FaBars size={22} className='mt-md-1 mt-2 ms-md-5 ms-0 d-lg-block d-none' style={{ color: '#2262c6', cursor: 'pointer' }} onClick={() => props.setSidebar(!props.sidebar)} />
                                <FaBars size={22} className='mt-md-1 mt-2 ms-md-5 ms-0 d-block d-lg-none' style={{ color: '#2262c6', cursor: 'pointer' }} data-bs-toggle="offcanvas" data-bs-target="#sideBar" aria-controls="offcanvasWithBothOptions" />
                            </>
                            : ''
                        }
                        {path !== '/course_quiz' ?
                            <Link to='/leader_board'>
                                <Button variant="outline-success" className='mt-md-1 mt-1 ms-md-3 ms-1 leaderboard-step'> <LuTrophy className='mb-1' /> Leader Board</Button>
                            </Link>
                            : ''
                        }
                    </div>
                    <div className='d-flex align-items-center'>
                        <div className='me-3 d-lg-block d-none'>Welcome <b>{user && user.vemp_fname}!</b><span className='ms-1 text-secondary' style={{ fontSize: '14px' }}>{'(' + user?.vrole_name + ')'}</span></div>

                        <div className="dropdown me-3">
                            <a className=" dropdown-toggle drop_toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={user?.vimage_name} alt="admin" className='img-fluid admin_img' onError={(e) => { e.target.src = "../Images/profile.jpg" }} />
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end nav_drop">
                                {/* <li><a className="dropdown-item nav_drop_list" href="#"><BiUser size={18} className='me-2' /> My Account</a></li>
                                <li><a className="dropdown-item nav_drop_list" href="#"><BsBriefcase size={18} className='me-2' /> My Activity</a></li>
                                <li><a className="dropdown-item nav_drop_list" href="#"><FiSettings size={18} className='me-2' /> Settings</a></li> */}
                                <li><span className="dropdown-item nav_drop_list" onClick={() => report_page()} style={{ cursor: 'pointer' }}><FaRegUser size={18} className='me-2' /> Profile</span></li>
                                {user?.vrole_name == 'Learner' ?
                                    <li className="nav_drop_list">
                                        <div className="form-check form-switch">
                                            <input className="form-check-input me-2" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={tour} onChange={(e) => tour_setting(e.target.checked)} />
                                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">LMS Tour</label>
                                        </div>
                                    </li>
                                    : ''
                                }
                                <li>
                                    <button className="dropdown-item nav_drop_list" onClick={() => form_16()} disabled={spinnerForm16 ? true : false}>
                                        <FaDownload size={18} className='me-2' /> Form 16
                                        {spinnerForm16 ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }
                                    </button>
                                </li>
                                <hr style={{ margin: 'inherit' }} />
                                <li>
                                    <button className="dropdown-item nav_drop_list" onClick={() => logout()} disabled={spinner ? true : false}>
                                        <FaPowerOff size={18} className='me-2' /> Log Out
                                        {spinner ?
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='ms-2'
                                            />
                                            : ''
                                        }
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div style={{ textDecoration: "none", color: "#2262c6", cursor: 'pointer' }} className="position-relative mt-md-1 mt-2 notification-step" onClick={() => navigate('/notification')}>
                            <FaRegBell size={22} className='' />
                            <span className="position-absolute top-0 left-5 start-100 translate-middle bg-danger border border-light rounded-circle p-1 text-light fw-semibold" style={{ fontSize: '12px' }}>
                                {count?.CountUnreadStatus > 10 ? '9+' : count?.CountUnreadStatus}
                            </span>
                        </div>
                    </div>
                </div>
            </nav>
            {props.sidebar && (<SIDEBAR />)}
        </>
    )

}